import { api } from '../index';

const USER_ACTIVITY_BASE_URL = 'api/user-activity';
const SALES_BASE_URL = 'api/reports-sales';
const METABASE_REPORTS_BASE_URL = 'api/reports';

async function getUserActivity(
  page: number,
  year: number
): Promise<UserActivityResponse> {
  const result = await api.get<UserActivityResponse>(
    `${USER_ACTIVITY_BASE_URL}?page=${page}&year=${year}`
  );
  return result.data;
}

async function getUserActivityStats(
  year: number
): Promise<UserActivityStatsResponse[]> {
  const result = await api.get<UserActivityStatsResponse[]>(
    `${USER_ACTIVITY_BASE_URL}/stats?year=${year}`
  );
  return result.data;
}

async function getUserSales(
  page: number,
  year: number
): Promise<PaginatedResponse<ReportsSalesResponse>> {
  const result = await api.get<PaginatedResponse<ReportsSalesResponse>>(
    `${SALES_BASE_URL}?page=${page}&year=${year}`
  );
  return result.data;
}

async function getUserSalesStats(
  year: number
): Promise<ReportsSalesStatsResponse> {
  const result = await api.get<ReportsSalesStatsResponse>(
    `${SALES_BASE_URL}/stats?year=${year}`
  );
  return result.data;
}

async function getMetabaseReport(
  reportId: number,
  params: MetabaseReportParameters
): Promise<MetabaseReportReponse> {
  const result = await api.get<MetabaseReportReponse>(
    `${METABASE_REPORTS_BASE_URL}/${reportId}`,
    { params }
  );
  return result.data;
}

async function getMetabaseReports(): Promise<MetabaseReportReponse[]> {
  const result = await api.get<MetabaseReportReponse[]>(
    `${METABASE_REPORTS_BASE_URL}`
  );
  return result.data;
}

async function getMetabaseProductReports(): Promise<MetabaseReportReponse[]> {
  const result = await api.get<MetabaseReportReponse[]>(
    `${METABASE_REPORTS_BASE_URL}/for_product`
  );
  return result.data;
}

export default {
  getUserActivity,
  getUserActivityStats,
  getUserSales,
  getUserSalesStats,
  getMetabaseReport,
  getMetabaseReports,
  getMetabaseProductReports,
};
